import { render, staticRenderFns } from "./SideMenuMobile.vue?vue&type=template&id=34c70e2a&scoped=true&"
import script from "./SideMenuMobile.vue?vue&type=script&lang=js&"
export * from "./SideMenuMobile.vue?vue&type=script&lang=js&"
import style0 from "./SideMenuMobile.vue?vue&type=style&index=0&id=34c70e2a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34c70e2a",
  null
  
)

export default component.exports